import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import common from 'src/styles/common.module.scss'

export const TextHeaderPt = () => {
    return (
        <HighlightedText
            text="GIRE A RODA E GANHE GIROS GRÁTIS"
            highlights={[{ word: 'GIROS' }, { word: 'GRÁTIS' }]}
            breakAfterWords={['GANHE']}
            className={common.text_header}
        />
    )
}
